import { render, staticRenderFns } from "./DeviceNameplate.vue?vue&type=template&id=af91059e&scoped=true"
import script from "./DeviceNameplate.vue?vue&type=script&lang=js"
export * from "./DeviceNameplate.vue?vue&type=script&lang=js"
import style0 from "./DeviceNameplate.vue?vue&type=style&index=0&id=af91059e&prod&scoped=true&lang=css"
import style1 from "./DeviceNameplate.vue?vue&type=style&index=1&id=af91059e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af91059e",
  null
  
)

export default component.exports